<div id="table-diagnosticos"></div>